import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const RegistrationComplete: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m660 660h-374.52v-30h344.52v-435c0-24.81-20.19-45-45-45h-435v245h-30v-275h465c41.35 0 75 33.64 75 75z' />
    <path d='m120 300h30v179.84h-30z' />
    <path d='m210 660h214.84s0-30 0-30h-184.84c-16.57 0-30 13.43-30 30z' />
    <path d='m390 463.54c-65.74 0-119.22-53.48-119.22-119.22s53.48-119.22 119.22-119.22 119.22 53.48 119.22 119.22-53.48 119.22-119.22 119.22zm0-208.45c-49.2 0-89.22 40.03-89.22 89.22s40.03 89.22 89.22 89.22 89.22-40.03 89.22-89.22-40.03-89.22-89.22-89.22z' />
    <path d='m540 539.91h-30c0-18.86-11.67-37.03-32.86-51.16-23.06-15.37-54.01-23.84-87.14-23.84s-64.08 8.47-87.14 23.84c-21.19 14.13-32.86 32.3-32.86 51.16h-30c0-29.22 16.41-56.25 46.22-76.12 27.93-18.62 64.79-28.88 103.78-28.88s75.84 10.26 103.78 28.88c29.81 19.87 46.22 46.9 46.22 76.12z' />
    <path d='m169.39 535.84-60.52 112.65-44.91-59.43c-13.23 9.97-15.86 28.78-5.88 42l33.14 43.9 6.78 9.05c2.95 3.93 7.45 6 12.01 6 3.13 0 6.29-.98 8.99-3 2.59-1.94 6-7 6-7l85-156.44c-14.6-7.82-32.79-2.33-40.61 12.28z' />
  </IconBase>
));

RegistrationComplete.displayName = 'RegistrationComplete';

export default RegistrationComplete;
